import React from 'react';
import { ActionsProps } from './types';
import { ArcButton, ArcStack } from '@src/core/ui';
import { useNavigate, useParams } from 'react-router-dom';
import { routesConfig } from '@src/core/routes';
import { MissionIdParams } from '@src/core/entities';
import { useCancelMissionMutation, useGetOrderMissionQuery } from '@src/features/order/redux';
import { toast } from 'react-toastify';
import { useConfirm } from '@src/core/controllers';

const Actions: React.FC<ActionsProps> = (props) => {
  const { isWarnings } = props;
  const navigate = useNavigate();
  const { missionId } = useParams<MissionIdParams>();
  const { data, isLoading } = useGetOrderMissionQuery(missionId);
  const [ cancelMission, { isLoading: isCanceling } ] = useCancelMissionMutation();
  const { confirm } = useConfirm();

  const onCancel = () => {
    cancelMission(missionId).unwrap().then(() => {
      toast.success('Mission has been canceled');
      navigate(routesConfig.orders, { replace: true });
    }).catch(() => {});
  };

  const onNext = () => {
    if (isWarnings) {
      confirm('The current weather conditions exceed safe limits for flight. Proceeding may put the drone at risk of damage or loss. Do you want to continue anyway?', 'Flight Confirmation').then((confirmed) => {
        if (confirmed) {
          navigate(`${routesConfig.orders}/checklist/${missionId}`);
        }
      });
    } else {
      navigate(`${routesConfig.orders}/checklist/${missionId}`);
    }
  };

  if (isLoading) return null;


  return (
    <ArcStack spacing={1}>

      <ArcStack spacing={1} direction='row'>
        <ArcButton.ghost 
          fullWidth 
          isLoading={isCanceling} 
          onClick={onCancel}> 
            CANCEL 
        </ArcButton.ghost>
        <ArcButton.ghost 
          fullWidth 
          onClick={() => navigate(routesConfig.orders)}> 
            EXIT 
        </ArcButton.ghost>
      </ArcStack>

      <ArcButton.brand 
        fullWidth
        onClick={onNext}> 
        NEXT 
      </ArcButton.brand>

    </ArcStack>
  );
};

export default Actions;